import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
export default store => ({
  path: "config",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "transcript-chunk" */ "./components"),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
});
